/**
 * SQLite schema and migrations for Electron offline POS (v4).
 */
export const SQLITE_SCHEMA_VERSION = 4;

export const MIGRATION_V1 = `
CREATE TABLE IF NOT EXISTS sync_meta (
  key TEXT PRIMARY KEY,
  version INTEGER NOT NULL DEFAULT 0
);

CREATE TABLE IF NOT EXISTS products (
  visible_id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  sku TEXT NOT NULL,
  barcode TEXT,
  description TEXT,
  sale_price_ht REAL NOT NULL,
  tax_rate REAL NOT NULL,
  category_id TEXT NOT NULL,
  is_active INTEGER NOT NULL DEFAULT 1,
  updated_at TEXT NOT NULL
);
CREATE INDEX IF NOT EXISTS idx_products_search ON products(name, sku, barcode);

CREATE TABLE IF NOT EXISTS categories (
  visible_id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  is_active INTEGER NOT NULL DEFAULT 1,
  is_free_sale_or_service INTEGER NOT NULL DEFAULT 0,
  is_free_price INTEGER NOT NULL DEFAULT 0,
  updated_at TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS branch_inventory (
  branch_id TEXT NOT NULL,
  product_id TEXT NOT NULL,
  stock INTEGER NOT NULL DEFAULT 0,
  exposed_on_site INTEGER,
  updated_at TEXT NOT NULL,
  PRIMARY KEY (branch_id, product_id)
);

CREATE TABLE IF NOT EXISTS outbox_ops (
  client_op_id TEXT PRIMARY KEY,
  kind TEXT NOT NULL,
  cart_id TEXT NOT NULL,
  upload_status TEXT NOT NULL,
  failed_attempts INTEGER NOT NULL DEFAULT 0,
  payload_json TEXT NOT NULL,
  local_receipt_id TEXT,
  created_at TEXT NOT NULL,
  last_error TEXT
);
CREATE UNIQUE INDEX IF NOT EXISTS idx_outbox_cart_sale ON outbox_ops(cart_id) WHERE kind = 'sale';

CREATE TABLE IF NOT EXISTS sales_history (
  id TEXT PRIMARY KEY,
  sale_visible_id TEXT NOT NULL,
  receipt_number TEXT NOT NULL,
  cart_id TEXT NOT NULL,
  branch_id TEXT NOT NULL,
  cashier_name TEXT NOT NULL,
  items_json TEXT NOT NULL,
  subtotal REAL NOT NULL,
  discount_percentage REAL NOT NULL,
  discount_amount REAL NOT NULL,
  grand_total REAL NOT NULL,
  payment_method TEXT NOT NULL,
  cash_given REAL NOT NULL,
  cash_returned REAL NOT NULL,
  created_at TEXT NOT NULL,
  status TEXT NOT NULL,
  pending_sync INTEGER NOT NULL DEFAULT 0
);
CREATE INDEX IF NOT EXISTS idx_sales_history_branch ON sales_history(branch_id, created_at DESC);

CREATE TABLE IF NOT EXISTS branches (
  visible_id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  code TEXT NOT NULL,
  address TEXT,
  is_main_branch INTEGER NOT NULL DEFAULT 0
);

CREATE TABLE IF NOT EXISTS auth_profiles (
  username TEXT NOT NULL,
  branch_id TEXT NOT NULL,
  branch_name TEXT,
  user_json TEXT NOT NULL,
  credential_verifier TEXT NOT NULL,
  encrypted_refresh_token TEXT,
  last_online_login_at TEXT NOT NULL,
  PRIMARY KEY (username, branch_id)
);

CREATE TABLE IF NOT EXISTS kv_meta (
  key TEXT PRIMARY KEY,
  value TEXT NOT NULL
);
`;

export const MIGRATION_V4 = `
CREATE TABLE IF NOT EXISTS receipt_id_aliases (
  old_id TEXT PRIMARY KEY,
  receipt_number TEXT NOT NULL,
  sale_visible_id TEXT NOT NULL,
  cart_id TEXT NOT NULL
);
CREATE INDEX IF NOT EXISTS idx_receipt_aliases_cart ON receipt_id_aliases(cart_id);
`;

export const MIGRATIONS: Record<number, string> = {
  1: MIGRATION_V1,
  4: MIGRATION_V4,
};
